export const MS_IN_TIME_UNITS = {
    WEEK: 604800000,
    DAY: 86400000,
    HOUR: 3600000,
    MINUTE: 60000,
    SECOND: 1000,
};
